export const HOME = {
  PUSH_CTA_DISCOVER: 'HOME_PUSH_CTA_DISCOVER',
  PUSH_CTA_LISTEN: 'HOME_PUSH_CTA_LISTEN',
  PUSH_CTA_EVENT: 'HOME_PUSH_CTA_EVENT',
  PUSH_CTA_DOWNLOAD: 'HOME_PUSH_CTA_DOWNLOAD',
  HOME_FILTER_INTERNATIONAL: 'HOME_HOME_FILTER_INTERNATIONAL',
  HOME_FILTER_NATIONAL: 'HOME_HOME_FILTER_NATIONAL',
  HOME_FILTER_REGIONAL: 'HOME_HOME_FILTER_REGIONAL',
  REGION_MENU_HOME: 'HOME_REGION_MENU_HOME',
  REGION_MENU_INTERNATIONAL: 'HOME_REGION_MENU_INTERNATIONAL',
  REGION_MENU_TITLE: 'HOME_REGION_MENU_TITLE',
};
